import '../commons/styles/footer.scss'
import './styles/newsList.scss'
import CommonHeader from '../commons/components/CommonHeader'
import CommonFooter from '../commons/components/CommonFooter'
import QrCodes from '../commons/components/QrCodes.vue'
// import NewsList from './NewsList'

Vue.config.productionTip = false
new Vue({
  render: h => h(CommonHeader, {
    props: {
      active: 'newsindex'
    }
  }),
}).$mount('#header')

new Vue({
  render: h => h(CommonFooter)
}).$mount('#footerCommon')

// new Vue({
//   render: h => h(NewsList),
// }).$mount('#app')

new Vue({
  render: h => h(QrCodes)
}).$mount('#qrCodes')